// extracted by mini-css-extract-plugin
export default {"badge":"CategoryBadge_badge__600O4"};